/* globals global, document, Backbone */
import qs from 'qs';

import { showError } from 'utils/messages';
import EasyPostConstants from 'app/easypost_constants';

export function appUrl(path) {
  return `/api/v2/${path}`;
}

export function fulfillmentUrl(path, version = 'v1') {
  return `/api/fulfillment/vendor/${version}/${path}`;
}

export function analyticsUrl(path) {
  return `/api/analytics/${path}`;
}

export function trackingPageUrl(path) {
  return `${EasyPostConstants.TrackingPageBase}/${path}`;
}

export function $body() {
  return $('body');
}

export function $contentArea() {
  return $body().find('#content-area');
}

export function location() {
  return window.location;
}

export function setLocation(l) {
  window.location = l;
}

export function $window() {
  return $(window);
}

export function scrollTop(offset) {
  return $window().scrollTop(offset || 0);
}

global.skipTimeouts = global.skipTimeouts || false;

export function setSkipTimeouts(val) {
  global.skipTimeouts = !!val;
}

export function setTimeout(fn, timeout) {
  if (global.skipTimeouts) {
    return fn();
  }

  return window.setTimeout(fn, timeout);
}

export function currentHash() {
  return location().hash;
}

export function getQueryParams() {
  /* '+' gets turned into a space by default, so we use a dumb decoder https://github.com/ljharb/qs/issues/205 */
  return qs.parse(location().search.substring(1), { decoder: s => s });
}

export function updateQueryParams(newParams) {
  const mergedParams = { ...getQueryParams(), ...newParams };
  const query = qs.stringify(mergedParams, { encode: false });

  // FIXME: wtf, why can't i use `location()` here like getQueryParams does?
  const { location: currentLocation } = window;
  Backbone.history.navigate(`${currentLocation.pathname}?${query}`, { replace: true });
}

export function submitPostViaHiddenForm({ action, target = '_blank', params }) {
  const form = $(`<form target="${target}" method="POST" style="display:none;"></form>`)
    .attr({ action }).appendTo(document.body);

  Object.keys(params).forEach(key => {
    $('<input type="hidden">').attr({
      name: key,
      value: params[key],
    }).appendTo(form);
  });
  form.submit();
  form.remove();
}

export function getFileReader() {
  return new window.FileReader();
}

export function errorIfNoFileReader(input) {
  if (!window.FileReader || !input.files || !input.files[0]) {
    const errMsg = 'Sorry, your browser doesn\'t support file uploads (FileReader API).';
    showError(errMsg);
    throw new Error(errMsg);
  }
}

export function downloadStringAsFile(string, filename) {
  const element = document.createElement('a');
  element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(string)}`);
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function autoAffix() {
  const headerHeight = 54; // FIXME: gross
  const affixAutoTopList = $('.affix-auto-top');
  if (affixAutoTopList.length) {
    const affixAutoBottom = $('.affix-auto-bottom');
    affixAutoTopList.each((idx, elem) => {
      const el = $(elem);
      const top = el.offset().top - headerHeight;
      if (affixAutoBottom.length) {
        el.affix({
          offset: {
            top,
            bottom: (
              $(document).height() -
              affixAutoBottom.offset().top -
              affixAutoBottom.outerHeight(true)
            ),
          },
        });
      } else {
        el.affix({ offset: { top } });
      }
      el.width(el.parent().width());
    });
  }
  return affixAutoTopList;
}



// WEBPACK FOOTER //
// ./utils/wrappers.js